export const images = {
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/ac734927-eda1-43ee-bf3e-440bddcc3650.jpg",
  family: "https://cdn.magicpatterns.com/patterns/generated-images/24dfd11b-a4a1-4b9a-b644-fba9cb521f97.jpg",
  office: "https://cdn.magicpatterns.com/patterns/generated-images/8ceb4f40-694e-477f-a1d9-84571aa51915.jpg",
  hands: "https://cdn.magicpatterns.com/patterns/generated-images/aef637b9-fd4c-428f-9344-c8d6c45a29eb.jpg",
  // [[FILL IN: owner photo]] — placeholder portrait until Victor's real photo is supplied
  victor: "https://cdn.magicpatterns.com/patterns/generated-images/5883787a-42be-431f-9f20-1b324ff06235.jpg",
};
